// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { classicFormat } from '@/hooks/format/useFormatNumber';

// Components
import { HalfBarChart } from '@/components/composite/Charts/HalfBarChart';

export const postEngagementHistoryConfig = {
    title: 'chart.instagram.post_engagements_history',
    tooltip: 'chart.instagram.post_engagements_history_tooltip',
    subtitle: 'chart.instagram.post_engagements_history_subtitle',
    id: 'post_engagements_history',
    margin: {
        left: -25,
        bottom: 20
    },
    orientation: 'horizontal',
    isStacked: true,
    name: {
        date: 'date',
        total: 'total',
        saves: 'chart.post_engagements.saves',
        comments: 'chart.post_engagements.comments',
        likes: 'chart.post_engagements.likes',
        replies: 'chart.post_engagements.replies',
        shares: 'chart.post_engagements.shares'
    },
    disableGraphData: ['posts'],
    valueFormat: classicFormat,
    size: SIZE_50,
    type: 'chart',
    element: HalfBarChart,
    color: {
        saves: 'pink',
        comments: 'yellow',
        likes: 'red',
        replies: 'blue',
        shares: 'aquablue'
    }
};
